import * as types from "../actions/actionTypes";

const initialState = {
  users: [],
  user: null,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_USER_RESPONSE:
      return { ...state, user: action.payload };
    case types.GET_ALL_USER_RESPONSE:
      return { ...state, users: action.payload };

    case types.CREATE_USER:
      return { ...state, user: null };
    case types.UPDATE_USER:
      return { ...state, user: null };
    case types.DELETE_USER:
      return { ...state, user: null };
    case types.CREATE_USER:
      return { ...state, user: null };
    default:
      return state;
  }
};

export default user;
